import { exec } from "@kakaopay-common/payweb-core";
import { INTERFACE } from "../../constants.mjs";
function getSelectedTabIndex() {
  return exec({ command: INTERFACE.GET_SELECTED_TAB_INDEX });
}
export {
  getSelectedTabIndex
};
